(function() {
    'use strict';
    angular
        .module('appback')
        .controller('RouteHistoryController', RouteHistoryController)

    RouteHistoryController.$inject = ["RouteHistoryService", "$filter"];

    function RouteHistoryController(RouteHistoryService, $filter) {
        var vm = this;
        vm.fieldName = "";
        vm.ruta = 0;
        vm.rutas = [];
        vm.from = "";
        vm.to = "";
        vm.errorMessage = "";
        vm.showError = function(msg) {
            vm.errorMessage = msg;
            var modalElement = document.getElementById('errorModal');
            if (modalElement) {
                var modal = new bootstrap.Modal(modalElement);
                modal.show();
            } else {
                alert(msg);
            }
        };

        vm.init = function() {
            RouteHistoryService.getRutas().then(function(response) {
                vm.rutas = response;
            }).catch(function(error) {
                vm.showError("No se pudieron cargar las rutas: " + (error.data.message || "Error desconocido"));
            });
        };

        vm.exportKilometraje = function() {
            let fechaDesde = $filter('date')(vm.from, 'yyyy-MM-dd');
            let fechaHasta = $filter('date')(vm.to, 'yyyy-MM-dd');
            let params = {
                ruta_id: vm.ruta,
                fecha_from: fechaDesde,
                fecha_to: fechaHasta
            };
            RouteHistoryService.exportHistorico(params)
                .then(function(response) {
                    if (response) {
                        window.location.href = '/backend/route/downloadreport?file_url=' + response;
                    }
                })
                .catch(function(error) {
                    let msg = "Error al exportar: ";
                    if (error.data && error.data.message) {
                        msg += error.data.message;
                    } else if (error.statusText) {
                        msg += error.statusText;
                    } else {
                        msg += "Ocurrió un problema inesperado.";
                    }
                    vm.showError(msg);
                });
        };


    }



})();
